module.exports = __webpack_public_path__ + "static/media/adobexd.9944e3aa.svg";